import api from './client';

export interface SignatureField {
  type: 'Signature' | 'Text' | 'Date' | 'Tampon';
  x: number;
  y: number;
  width: number;
  height: number;
  page?: number;
  content?: string;
  label?: string;
}

export interface SignatureRequest {
  pdf_file?: File | Blob;
  pdf_url?: string;
  fields: SignatureField[];
  target_width: number;
  target_height: number;
  filename?: string;
}

export interface SignatureResponse {
  document_id: string;
  signed_file_url: string;
  signed_file_path: string;
  pdf_url: string;
  vierge_pdf_url?: string;
  status: string;
  message?: string;
}

export const signaturesApi = {
  /**
   * Sign a PDF document with signature fields
   * @param request - Signature request with PDF file and fields
   * @returns Signed document with temporary signed URL
   */
  sign: async (request: SignatureRequest): Promise<SignatureResponse> => {
    const formData = new FormData();
    if (request.pdf_file) {
      formData.append('pdf_file', request.pdf_file);
    }
    if (request.pdf_url) {
      formData.append('pdf_url', request.pdf_url);
    }
    formData.append('fields', JSON.stringify(request.fields));
    formData.append('target_width', request.target_width.toString());
    formData.append('target_height', request.target_height.toString());
    if (request.filename) {
      formData.append('filename', request.filename);
    }

    const { data } = await api.post('/signatures/sign', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  /**
   * Prepare a PDF for signing (highlight empty fields)
   * @param request - Prepare request with PDF file and fields
   * @returns Prepared document with temporary signed URL
   */
  prepare: async (request: SignatureRequest): Promise<SignatureResponse> => {
    const formData = new FormData();
    if (request.pdf_file) {
      formData.append('pdf_file', request.pdf_file);
    }
    formData.append('fields', JSON.stringify(request.fields));
    formData.append('target_width', request.target_width.toString());
    formData.append('target_height', request.target_height.toString());
    if (request.filename) {
      formData.append('filename', request.filename);
    }

    const { data } = await api.post('/signatures/prepare', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
};
